export const ADD_USER = 'ADD_USER';
export const EDIT_USER = 'EDIT_USER';
export const GET_USERS = 'GET_USERS';
export const GET_USER_SALES = 'GET_USER_SALES';
export const GET_USER_WINNINGS = 'GET_USER_WINNINGS';
export const GET_UNIQUE_USER = 'GET_UNIQUE_USER';
export const DELETE_USER = 'DELETE_USER';
export const GET_LOGGED_USER = 'GET_LOGGED_USER';